// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-face-content .el-radio__label {\n  color: #606266;\n}\n.my-face-content .el-radio.is-checked .el-radio__label {\n  color: #1890ff;\n}\n", ""]);
// Exports
module.exports = exports;
